import type { AttachedKnowledgeBaseEntry } from "@/types/api/TestCaseRecord"
import type {
  TestCaseExpectedOutput,
  TestCaseMetricInput,
  TestCaseSimulationMetadataInput,
} from "@/types/backend-contracts"
import type { ScriptTurn } from "@/types/ScriptTurn"

export const ALLOWED_MEDIA_MIME_TYPES = ["image/png", "image/jpeg"] as const
export type AllowedMediaMimeType = (typeof ALLOWED_MEDIA_MIME_TYPES)[number]

export const MAX_MEDIA_FILE_SIZE_BYTES = 2 * 1024 * 1024 // 2 MB

export interface MediaAttachment {
  name: string // user-defined name used by the persona to reference it
  s3_key: string
  s3_bucket: string
  mime_type: AllowedMediaMimeType
  description?: string // optional human description for the persona prompt
}

export interface TestCaseInput {
  input_str: string
  description?: string | null
  expected_behaviors: string[]
  expected_output_json?: TestCaseExpectedOutput | null
  s3_key: string | null
  s3_bucket: string | null
  input_type: string
  script_turns?: ScriptTurn[] | null
  simulation_metadata_input?: TestCaseSimulationMetadataInput | null
  metric_input?: TestCaseMetricInput | null
  connected_knowledge_base_entries?: AttachedKnowledgeBaseEntry[]
  media_attachments?: MediaAttachment[]
}
